var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732,
    height: 600,
    viewBox: "0 0 732 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Results"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M25.8398 276.557V282.753",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M11.918 279.911L16.9809 285.123",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M6 293.786H13.159",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M11.3438 307.907L16.4067 302.695",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M25.8398 309.6V303.404",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M36.1697 305.472L32.0391 301.342",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M44.4225 295.146H38.2266",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M40.2947 280.688L36.1641 284.818",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M358.359 6V10.1306",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M345.961 18.3926H350.092",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M358.359 30.7849V26.6543",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M368.678 18.3926H364.547",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M118.781 179.487V185.683",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M100.195 198.073H106.391",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M118.781 214.596V208.4",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M135.301 198.073H129.105",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M563.353 404.684C568.288 404.684 572.291 408.688 572.291 413.625C572.291 418.563 568.288 422.566 563.353 422.566C558.417 422.566 554.414 418.563 554.414 413.625",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.254 323.568C609.561 321.912 617.697 315.421 619.58 308.438C621.288 314.611 628.447 321.912 634.906 322.465C627.635 325.039 620.683 332.688 619.58 338.696C618.83 332.572 609.214 324.46 604.254 323.568Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4492 401.929C62.1038 401.102 66.1699 397.857 67.1114 394.365C67.9653 397.45 71.544 401.102 74.7737 401.379C71.1389 402.664 67.6637 406.489 67.1114 409.494C66.7362 406.432 61.9285 402.375 59.4492 401.929Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.714 114.628C108.714 118.459 105.61 121.561 101.783 121.561C97.9533 121.561 94.8516 118.459 94.8516 114.628C94.8516 110.8 97.9533 107.695 101.783 107.695C105.61 107.695 108.714 110.8 108.714 114.628Z",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.538 133.243C571.538 139.643 566.35 144.83 559.953 144.83C553.554 144.83 548.367 139.643 548.367 133.243C548.367 126.843 553.554 121.655 559.953 121.655C566.35 121.655 571.538 126.843 571.538 133.243Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M732.002 101.849C732.002 106.926 727.889 111.041 722.814 111.041C717.738 111.041 713.625 106.926 713.625 101.849C713.625 96.7717 717.738 92.6572 722.814 92.6572C727.889 92.6572 732.002 96.7717 732.002 101.849Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.249 531.14C238.249 534.341 235.655 536.935 232.455 536.935C229.257 536.935 226.664 534.341 226.664 531.14C226.664 527.94 229.257 525.346 232.455 525.346C235.655 525.346 238.249 527.94 238.249 531.14Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.796 70.0882C234.796 73.9185 231.692 77.021 227.865 77.021C224.037 77.021 220.934 73.9185 220.934 70.0882C220.934 66.2595 224.037 63.1553 227.865 63.1553C231.692 63.1553 234.796 66.2595 234.796 70.0882Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.595 595.307C407.166 596.992 402.209 594.767 400.524 590.338C398.839 585.908 401.062 580.948 405.493 579.265C409.92 577.579 414.877 579.803 416.562 584.233C418.249 588.663 416.024 593.621 411.595 595.307Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.01093,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.954 431.457H239.589C227.668 431.457 217.91 421.671 217.91 409.71V168.186C217.91 156.225 227.668 146.443 239.589 146.443H408.954C420.88 146.443 430.638 156.225 430.638 168.186V409.71C430.638 421.671 420.88 431.457 408.954 431.457Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.505 441.784H225.14C213.219 441.784 203.461 431.998 203.461 420.037V178.513C203.461 166.552 213.219 156.771 225.14 156.771H394.505C406.431 156.771 416.189 166.552 416.189 178.513V420.037C416.189 431.998 406.431 441.784 394.505 441.784Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.439 449.935H210.723C198.778 449.935 189 440.189 189 428.278V187.754C189 175.843 198.778 166.102 210.723 166.102H380.439C392.389 166.102 402.167 175.843 402.167 187.754V428.278C402.167 440.189 392.389 449.935 380.439 449.935Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.439 449.935H210.723C198.778 449.935 189 440.189 189 428.278V187.754C189 175.843 198.778 166.102 210.723 166.102H380.439C392.389 166.102 402.167 175.843 402.167 187.754V428.278C402.167 440.189 392.389 449.935 380.439 449.935Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.975 239.384H230.62C227.04 239.384 224.109 236.596 224.109 233.19C224.109 229.78 227.04 226.992 230.62 226.992H355.975C359.555 226.992 362.486 229.78 362.486 233.19C362.486 236.596 359.555 239.384 355.975 239.384Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.975 276.559H230.62C227.04 276.559 224.109 273.771 224.109 270.365C224.109 266.955 227.04 264.167 230.62 264.167H355.975C359.555 264.167 362.486 266.955 362.486 270.365C362.486 273.771 359.555 276.559 355.975 276.559Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.975 313.734H230.62C227.04 313.734 224.109 310.946 224.109 307.54C224.109 304.134 227.04 301.342 230.62 301.342H355.975C359.555 301.342 362.486 304.134 362.486 307.54C362.486 310.946 359.555 313.734 355.975 313.734Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.975 350.909H230.62C227.04 350.909 224.109 348.121 224.109 344.715C224.109 341.304 227.04 338.517 230.62 338.517H355.975C359.555 338.517 362.486 341.304 362.486 344.715C362.486 348.121 359.555 350.909 355.975 350.909Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.053 388.086H230.648C227.052 388.086 224.109 385.298 224.109 381.893C224.109 378.482 227.052 375.694 230.648 375.694H296.053C299.649 375.694 302.591 378.482 302.591 381.893C302.591 385.298 299.649 388.086 296.053 388.086Z",
    fill: "#E0E2EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.077 340.038C403.011 365.099 364.205 367.927 336.033 348.577C332.433 346.06 329.006 343.233 325.81 340.038C324.165 338.398 322.614 336.706 321.153 334.924C318.231 331.366 315.671 327.572 313.574 323.652C309.879 317.03 307.366 310.004 305.995 302.742C301.569 279.966 308.186 255.45 325.81 237.835C343.476 220.167 367.995 213.593 390.775 217.976C398.033 219.389 405.066 221.901 411.689 225.554C415.615 227.698 419.357 230.257 422.921 233.179C424.697 234.635 426.39 236.19 428.03 237.835C431.231 241.03 434.1 244.451 436.571 248.056C455.929 276.219 453.096 315.023 428.077 340.038Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.062 335.104C394.984 361.186 352.723 361.182 326.64 335.104C300.591 309.055 300.591 266.789 326.674 240.711C352.723 214.662 394.984 214.662 421.033 240.711C447.111 266.789 447.111 309.055 421.062 335.104ZM434.446 227.312C400.972 193.839 346.73 193.839 313.257 227.312C279.788 260.78 279.759 315.057 313.227 348.53C343.692 378.985 391.442 381.732 425.027 356.726C428.307 354.281 431.466 351.539 434.48 348.53C437.488 345.517 440.23 342.358 442.671 339.077C467.676 305.488 464.905 257.772 434.446 227.312Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.175 474.708L564.769 476.113C555.472 485.415 540.248 485.415 530.946 476.113L445.102 390.269L480.33 355.04L566.175 440.885C575.477 450.186 575.477 465.406 566.175 474.708Z",
    fill: "url(#paint0_linear_2496_35348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.52 336.451L469.887 361.819L451.878 379.823L426.516 354.455C429.863 351.96 433.082 349.162 436.161 346.092C439.232 343.022 442.029 339.799 444.52 336.451Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.888 439.827L529.884 474.827L523.582 468.52L558.582 433.521L564.888 439.827Z",
    fill: "#EF545F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.283 356.252L446.32 392.216L440.977 386.873L476.94 350.909L482.283 356.252Z",
    fill: "url(#paint1_linear_2496_35348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.794 231.737L315.597 319.928C312.276 313.976 310.017 307.659 308.789 301.13L384.994 224.924C391.519 226.199 397.841 228.453 403.794 231.737Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.712 252.7L337.362 342.648C333.947 340.4 330.697 337.87 327.667 335.011C326.106 333.539 324.631 332.029 323.25 330.435L419.761 239.382C421.451 240.689 423.056 242.081 424.611 243.553C427.642 246.412 430.369 249.474 432.712 252.7Z",
    fill: "white",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2496_35348",
    x1: 509.126,
    y1: 291.015,
    x2: 381.077,
    y2: 419.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2496_35348",
    x1: 461.63,
    y1: 330.256,
    x2: 420.323,
    y2: 371.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/searchEmpty.2fd6de127a39bd8460229fc604cd4cbe.svg";
export { ForwardRef as ReactComponent };